import db from './fakedb.json'

export default (code) => {
  return db.find((el) => {
    if (code === el.code || code === el._id) {
      return el
    }
  })
}
